import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import {
  VACANCY_OVERVIEW_URL,
  VACANCY_OVERVIEW_MAP_URL,
} from '../../config/constants';

import './style.scss';

const ListMapToggler = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const activeListClass = location.pathname === VACANCY_OVERVIEW_MAP_URL ? '' : 'active';
  const activeMapClass = location.pathname === VACANCY_OVERVIEW_MAP_URL ? 'active' : '';

  return (
    <div className="listMapToggler">
      <CoreLink
        to={VACANCY_OVERVIEW_URL}
        primary
      >
        <div className={`listMapToggler__button listMapToggler__button__left ${activeListClass}`}>
          <span className="icon icon-list icon-variant-2" />
          <span>{t('general.list')}</span>
          <div className={`listMapToggler__line ${activeListClass}`} />
        </div>
      </CoreLink>
      <CoreLink
        to={VACANCY_OVERVIEW_MAP_URL}
        primary
      >
        <div className={`listMapToggler__button listMapToggler__button__right ${activeMapClass}`}>
          <span className="icon icon-map icon-variant-2" />
          <span>{t('general.map')}</span>
          <div className={`listMapToggler__line ${activeMapClass}`} />
        </div>
      </CoreLink>
    </div>
  );
};

export default ListMapToggler;
